import React, { useLayoutEffect, useState } from 'react';
import { FORM_STEP_CLASS, SURFACE_CONTENT_CLASS, getSurfaceEnterClass } from '../Util/pageTransition';

/**
 * One whole surface of an embedded form: the campaign detail page, or the form. Switching between
 * them keeps the card still (FORM_STEP_CLASS) and slides only the card's content
 * (SURFACE_CONTENT_CLASS inside it), once per switch: the enter class is set when the surface
 * becomes active and cleared when the slide ends, so a later step-to-step slide inside the form is
 * never overridden. EmbedForm and EventForm render their two surfaces through this.
 */
export default function FormSurfacePage({ active, direction, formDisplayMode, className = '', children }) {
  const [entering, setEntering] = useState(false);

  // Before paint, so the entering content never shows a frame in its resting place first.
  useLayoutEffect(() => {
    setEntering(Boolean(active && direction));
  }, [active, direction]);

  const enterClass = entering ? getSurfaceEnterClass(direction, formDisplayMode) : '';
  const handleAnimationEnd = (event) => {
    if (entering && event.target.classList?.contains(SURFACE_CONTENT_CLASS)) setEntering(false);
  };

  return (
    <div
      className={`page ${FORM_STEP_CLASS} ${active ? 'active' : ''} ${enterClass} ${className}`.replace(/\s+/g, ' ').trim()}
      onAnimationEnd={handleAnimationEnd}
    >
      {children}
    </div>
  );
}
